import { FilterConditionOutput } from '@shared/components/ui/AdvancedFilter';
import { FiltersDropdown } from '@shared/components/ui/FiltersDropdown';
import { Search } from '@shared/components/ui/Search';
import { ChangeEvent, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DownloadExcelButton } from './DownloadExcelButton';
import { ImportHistoryFiltersPanel } from './ImportHistoryFiltersPanel';

interface FiltersSectionProps {
  handleSearch: (value: string) => void;
  onFilterChange?: (conditions: FilterConditionOutput[]) => void;
  searchTerm: string;
  filterConditions: FilterConditionOutput[];
  filters: any; // Para pasar al DownloadExcelButton
}

export const FiltersSection = ({
  handleSearch,
  onFilterChange,
  searchTerm,
  filterConditions,
  filters,
}: FiltersSectionProps) => {
  const { t } = useTranslation('shopsModule');
  const [inputValue, setInputValue] = useState(searchTerm);

  useEffect(() => {
    setInputValue((prev) => (prev === searchTerm ? prev : searchTerm));
  }, [searchTerm]);

  const activeFiltersCount = useMemo(() => {
    return filterConditions.length;
  }, [filterConditions]);

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const handleSearchSubmit = () => {
    handleSearch(inputValue.trim());
  };

  return (
    <>
      <Search
        placeholder={t('importHistory.search.placeholder', 'Buscar por referencia externa...')}
        value={inputValue}
        onChange={handleInputChange}
        onEnter={handleSearchSubmit}
        dataTestId="search"
        inputDataTestId="search-input"
      />

      <FiltersDropdown
        title={t('filters.title', 'Filtros')}
        activeFiltersCount={activeFiltersCount}
        triggerTestId="filters-toggle-button"
      >
        <ImportHistoryFiltersPanel initialConditions={filterConditions} onChange={onFilterChange} />
      </FiltersDropdown>

      <DownloadExcelButton filters={filters} />
    </>
  );
};
